import { Injectable } from "@angular/core";
import { ConfigurationPage } from '../pages/invoice/invoice-jobs/ConfigurationPage';
import { CanDeactivate } from '@angular/router';

@Injectable()
export class ConfigurationDeactivateGuard implements CanDeactivate<ConfigurationPage> {
    canDeactivate(target: ConfigurationPage){

        if (target.currentInputDocument != undefined) {
            if (window.confirm('You are currently working on a document! Are you sure you want to leave?')) {
                target.ReleaseDocument();
                return true;
            }
            return false;
        }
        return true;
   }
}